import React from 'react'
export default()=>(
    <style js="true">{
        `

        .button-text-header {
            font-size: 28px;
            margin-top: -1px;
            color: white;
            text-align:center;
        }

        .button-section2-header {
            height: 53px!important;
            width: 200px!important;
            margin-top:40px!important;
            font-size:28px;
        
        }
        .button-header-text {
            padding-left: 15px;
            margin-top: -2px;
            color: white;
            font-size: 24px;
        }
        .content{
            margin-right:30px;
        }
        a{
            text-decoration: none!important;
        }
        button#clip-div1 {
            background-image: linear-gradient(#F37F00, #fdb05b);
            border: #e07900;
            margin-left: 34px;
            margin-top: 26px!important;
            border-radius: 37px;
            height: 60px!important;
            background-color: #e87e00;
            width: 202px!important;
            }


        /* section1  starts here*/
        .section1-row{
            padding-top: 1%;
        }
        .section1-row {
            margin-bottom: -16px;
        }
        .section1-paragraph{
            display: flex;
            padding-top: 2%;
            
        }
        // .section1-paragraph a:hover{
        //     color: #006a90;
        //     text-decoration: none;
        //     list-style: none;
        // }
        .section1-paragraph a{
            color:#004e76!important;
            margin-top: 2px;
            color: #0b567b!important;
        }

        .anchor-section1 
        {
            color: #0b567b!important;
            text-decoration: none;
            font-size: 33px;
            margin-right: 6px;
            padding: 5px;
        }
        .section1-paragraph h4{
            font-size: 35px;
            // font-weight: bold;
            padding-top: 1.5%;
            color:#004e76;
        }
        .section1-paragraph p{
            padding-top: 10px;
        }
        .paragragh2-section1{
            margin-top:-20px ;
        }
        .below-anchor{
            text-align: end;
            margin-top: -5px;
        }
        .below-anchor p{
            font-size: 17px;
            
        }
        .link-header {
            margin-top: -5px;
            color: #ea840b;
            margin-right: -19px;
            font-weight: 500;
        }


        `
    }

    </style>
);